let mfLegacyGiftCleanupRunning = false;

const mfIsCheckoutSurface = () => {
  const drawer = document.querySelector('cart-drawer');
  return window.location.pathname === '/cart' || drawer?.classList.contains('open');
};

const mfHideCheckoutClaim = () => {
  if (!mfIsCheckoutSurface()) return;

  document.querySelectorAll('[class*="trustoo" i], [id*="trustoo" i]').forEach((element) => {
    element.style.setProperty('display', 'none', 'important');
    element.setAttribute('data-mf-checkout-claim-hidden', 'true');
  });

  const claimPattern = /claim\s*15%\s*off/i;
  document.querySelectorAll('body *').forEach((element) => {
    if (element.hasAttribute('data-mf-checkout-claim-hidden')) return;

    const text = element.textContent?.replace(/\s+/g, ' ').trim() || '';
    if (!claimPattern.test(text) || text.length > 80 || element.children.length > 2) return;

    let target = element;
    for (let ancestor = element; ancestor && ancestor !== document.body; ancestor = ancestor.parentElement) {
      if (['fixed', 'sticky'].includes(window.getComputedStyle(ancestor).position)) {
        target = ancestor;
        break;
      }
    }

    target.style.setProperty('display', 'none', 'important');
    target.setAttribute('data-mf-checkout-claim-hidden', 'true');
  });
};

const mfScheduleCheckoutClaimCleanup = () => {
  if (mfCheckoutClaimCleanupScheduled) return;
  mfCheckoutClaimCleanupScheduled = true;
  requestAnimationFrame(() => {
    mfCheckoutClaimCleanupScheduled = false;
    mfHideCheckoutClaim();
  });
};

let mfCheckoutClaimCleanupScheduled = false;

const mfRefreshCartDrawer = (state) => {
  const drawer = document.querySelector('cart-drawer');

  if (drawer?.renderContents) {
    drawer.renderContents(state);
  }

  document.dispatchEvent(new CustomEvent('cart:updated', {
    detail: { cart: state },
  }));
};

let mfCartRecommendationsLoadScheduled = false;

const mfLoadCartRecommendations = () => {
  document.querySelectorAll(
    'cart-drawer product-recommendations[data-url], #CartDrawer product-recommendations[data-url], .main-cart product-recommendations[data-url]'
  ).forEach((element) => {
    if (element.dataset.mfRecommendationState || element.querySelector('.slider__grid')) return;

    const url = element.dataset.url;
    if (!url) return;

    element.dataset.mfRecommendationState = 'loading';

    fetch(url, { headers: { Accept: 'text/html' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Recommendation request failed: ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        const section = recommendations?.querySelector('.section-container');
        const hasContent = recommendations
          && recommendations.innerHTML.trim().length
          && (!section || section.innerHTML.trim().length);

        if (!hasContent) {
          if (!element.closest('.tabs-block')) element.remove();
          else element.dataset.mfRecommendationState = 'empty';
          return;
        }

        const replacement = document.createElement('div');
        Array.from(element.attributes).forEach(({ name, value }) => {
          if (name !== 'data-url') replacement.setAttribute(name, value);
        });
        replacement.dataset.mfRecommendationState = 'loaded';
        replacement.innerHTML = recommendations.innerHTML;
        element.replaceWith(replacement);
        document.dispatchEvent(new CustomEvent('recommendations:loaded'));
      })
      .catch((error) => {
        delete element.dataset.mfRecommendationState;
        console.error('[Mantra Flow cart] Recommendations preload failed:', error);
      });
  });

  const recentlyViewedSelector = [
    'cart-drawer recently-viewed-products[data-url]',
    '#CartDrawer recently-viewed-products[data-url]',
    '.main-cart recently-viewed-products[data-url]',
  ].join(', ');

  document.querySelectorAll(recentlyViewedSelector).forEach((element) => {
    if (element.dataset.mfRecommendationState || element.querySelector('.slider__grid')) return;

    let viewedIds = [];
    try {
      viewedIds = JSON.parse(window.localStorage.getItem('volume-theme:recently-viewed') || '[]')
        .filter((id) => id != null);
    } catch (error) {
      viewedIds = [];
    }

    const query = viewedIds.map((id) => `id:${id}`).slice(0, 10).join(' OR ');
    if (!query) return;

    element.dataset.mfRecommendationState = 'loading';

    fetch(`${element.dataset.url}${query}`, { headers: { Accept: 'text/html' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Recently viewed request failed: ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recentlyViewed = html.querySelector('recently-viewed-products');
        const slider = recentlyViewed?.querySelector('slider-component');

        if (!slider?.innerHTML.trim()) {
          if (!element.closest('.tabs-block')) element.remove();
          else element.dataset.mfRecommendationState = 'empty';
          return;
        }

        const replacement = document.createElement('div');
        Array.from(element.attributes).forEach(({ name, value }) => {
          if (name !== 'data-url') replacement.setAttribute(name, value);
        });
        replacement.dataset.mfRecommendationState = 'loaded';
        replacement.innerHTML = recentlyViewed.innerHTML;
        element.replaceWith(replacement);
        document.dispatchEvent(new CustomEvent('recommendations:loaded'));
      })
      .catch((error) => {
        delete element.dataset.mfRecommendationState;
        console.error('[Mantra Flow cart] Recently viewed preload failed:', error);
      });
  });
};

const mfScheduleCartRecommendations = () => {
  if (mfCartRecommendationsLoadScheduled) return;
  mfCartRecommendationsLoadScheduled = true;
  requestAnimationFrame(() => {
    mfCartRecommendationsLoadScheduled = false;
    mfLoadCartRecommendations();
  });
};

const mfRemoveLegacyGift = async () => {
  const drawer = document.querySelector('cart-drawer');
  const lineKey = drawer?.dataset.mfPaidGiftLineKey;

  if (!drawer || !lineKey || mfLegacyGiftCleanupRunning) return;

  mfLegacyGiftCleanupRunning = true;

  try {
    const sections = drawer.getSectionsToRender?.().map((section) => section.id) || [];
    const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        updates: { [lineKey]: 0 },
        attributes: { mf_gift_of_fate_choice: '' },
        sections,
        sections_url: window.location.pathname,
      }),
    });
    const state = await response.json();

    if (!response.ok || state.status) {
      throw new Error(state.description || state.message || 'Unable to remove the retired gift item.');
    }

    mfRefreshCartDrawer(state);
  } catch (error) {
    console.error('[Mantra Flow cart] Legacy gift cleanup failed:', error);
  } finally {
    mfLegacyGiftCleanupRunning = false;
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    mfRemoveLegacyGift();
    mfScheduleCheckoutClaimCleanup();
    mfScheduleCartRecommendations();
  }, { once: true });
} else {
  mfRemoveLegacyGift();
  mfScheduleCheckoutClaimCleanup();
  mfScheduleCartRecommendations();
}

window.addEventListener('load', mfScheduleCartRecommendations, { once: true });
document.addEventListener('shopify:section:load', mfScheduleCartRecommendations);

document.addEventListener('cart:updated', () => {
  window.setTimeout(mfRemoveLegacyGift, 0);
  mfScheduleCheckoutClaimCleanup();
  mfScheduleCartRecommendations();
});

document.addEventListener('body:visible', mfScheduleCheckoutClaimCleanup);
document.addEventListener('body:visible', mfScheduleCartRecommendations);
document.addEventListener('click', () => {
  mfScheduleCheckoutClaimCleanup();
  mfScheduleCartRecommendations();
}, true);

if (document.body) {
  new MutationObserver(() => {
    mfScheduleCheckoutClaimCleanup();
    mfScheduleCartRecommendations();
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
}
